import React, { useEffect, useState } from 'react';
import { lazy, Suspense } from 'react';
import {
  useRoutes,
  useSearchParams,
  useNavigate, 
  useLocation
} from 'react-router-dom';
import { TabBar } from 'antd-mobile'
import {
  AppOutline,
  MessageOutline,
  UnorderedListOutline,
  AppstoreOutline,
  QuestionCircleOutline
} from 'antd-mobile-icons'
import { withCache } from './withCache'
import List from '@/view/list'
import Detail from '@/view/detail';
import { getGameXunShowType, getNowGameList } from '@/api/index';

import './index.less';

const Home = lazy(() => import('@/view/home'));
const FilterList = lazy(() => import('@/view/game-list'));
const AllFilterList = lazy(() => import('@/view/all-game-list'));
const Login = lazy(() => import('@/view/login'));

const CacheAbleList = withCache(List)

// 路由懒加载，需配合Suspense使用
const lazyLoad = (children) => {
  return <Suspense fallback={<h2>Loading..</h2>}>{children}</Suspense>;
};

const Bottom = ({ gameOne, buttonInfo }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [search] = useSearchParams();
  const { pathname } = location;


  const goCustomer = (url) => {
    const URL = 'https://mobile.yangkeduo.com/mall_page.html?mall_id=372330997&msn=xtlfhtl63xp3wp2ggw22wzrxje_axbuy&_x_outbound_channel=__outbound_mall__';
    const ROUTER = `${url || URL}&Url=${encodeURI((window.location.hash).split('#')?.[1])}`;
    const user = navigator.userAgent;
      //android端
      const isiOS = !!user.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if(isiOS) {  
          window.location.href = ROUTER;
      }else{ 
        window.open(ROUTER, '_blank')
      }
  }

  const getCookie = (cookieName) => {
    const strCookie = document.cookie
    const cookieList = strCookie.split(';')
    
    for(let i = 0; i < cookieList.length; i++) {
      const arr = cookieList[i].split('=')
      if (cookieName === arr[0].trim()) {
        return arr[1]
      }
    }
    
    return ''
  }

  const setRouteActive = (value) => {
    switch(value){
      case '/gamelist':
        document.cookie=`gameName=${gameOne?.gamename}`
        document.cookie=`gameId=${gameOne?.gameid}`
        navigate(`/gamelist?id=${ getCookie('gameId') || gameOne?.gameid}`);
        break;
      case '/custom':
        goCustomer(buttonInfo?.data?.button_list?.button_item_shop?.[0]?.url);
        break;
      default:
        navigate(value)
    }
  }

  const tabs = [
    {
      key: '/',
      title: '首页',
      icon: <AppOutline />,
    },
    {
      key: '/gamelist',
      title: getCookie('gameName') || gameOne?.gamename,
      icon: <UnorderedListOutline />,
    },
    {
      key: '/all-list',
      title: '全部游戏',
      icon: <AppstoreOutline />,
    },
    {
      key: '/custom',
      title: '客服',
      icon: <MessageOutline />,
    },
    {
      key: '/help',
      title: '帮助',
      icon: <QuestionCircleOutline />,
    }
  ]


  return (
    <TabBar activeKey={pathname} onChange={value => setRouteActive(value)}>
      {tabs.map(item => (
        <TabBar.Item key={item.key} icon={item.icon} title={item.title} />
      ))}
    </TabBar>
  )
}
const AppRouter = ()   => {
  const [gameList, setGameList] = useState([]);
  const [buttonInfo, setButtonInfo] = useState({});
  const [lock, setLock] = useState('');
  const routes =  useRoutes([
    {
        path: '/',
        element: lazyLoad(<Home buttonInfo={buttonInfo} gameList={gameList} />),
    },
    {
        path: '/gamelist',
        element: <CacheAbleList buttonInfoData={buttonInfo} />,
        children: [{ path: ':id', element: <Detail /> }],
    },
    { path: '/filter-list', element: lazyLoad(<FilterList />) },
    { path: '/all-list', element: lazyLoad(<AllFilterList />) },
    { path: '/login', element: lazyLoad(<Login />) },
  ]);

  const getInfo = async() => {
    const res = await getGameXunShowType();
    setButtonInfo(res?.data);
    setLock(res?.data?.lock);
    document.title = res?.data?.data?.title;
  }
  useEffect(()=>{
    getInfo();
    getNowGameList().then(res => {
      const { data } = res;
      setGameList(data?.data)
    })
  }, [])
  return (
      <div className="app">
          <div className="app-body">
            {routes}
          </div>
          <div className="app-footer">
            <Bottom gameOne={gameList?.[0]} buttonInfo={buttonInfo}/>
          </div>
      </div>
  )
};

export default AppRouter;